import { PaymentMethod } from '../paymentMethod/paymentMethod';
import { Person } from '../person/person';

export class Customer extends Person {
  id: string;
  merchantId: string;
  //streetAddress: Partial<StreetAddress> | undefined;
  paymentMethods: PaymentMethod[] = [];

  constructor(c: Partial<Customer>) {
    //let json = JSON.parse(JSON.stringify(c));

    super(c);

    if (c.id == null)
      throw new Error(
        `Invalid customer in constructor: ${JSON.stringify(c)} id cannot be null`,
      );

    if (c.merchantId == null)
      throw new Error(
        `Invalid customer in constructor: ${JSON.stringify(c)} merchantId cannot be null`,
      );

    this.id = c.id;
    this.merchantId = c.merchantId;

    if (c.paymentMethods) {
      this.paymentMethods = c.paymentMethods;
    }
  }

  clone(): Customer {
    return new Customer(JSON.parse(JSON.stringify(this)));
  }


  static override createEmpty(): Partial<Customer> {
    const customer = super.createEmpty() as Partial<Customer>;
    customer.paymentMethods = [];

    return customer;
  }
}
